import { ReactNode, useState, useEffect, Suspense, lazy } from 'react';
import Header from './Header';
import Footer from './Footer';
import Preloader from './Preloader';
import WhatsAppButton from './WhatsAppButton';
import ScrollToTop from './ScrollToTop';

// Lazy load AIChatButton to keep the initial page bundle minimal and fast
const AIChatButton = lazy(() => import('./AIChatButton'));

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [mountChat, setMountChat] = useState(false);

  useEffect(() => {
    // Delay mounting AIChatButton by 2 seconds to let the critical LCP assets render uninterrupted
    const timer = setTimeout(() => {
      setMountChat(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <a 
        href="#main-content" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-brand-accent focus:text-brand-dark focus:rounded-lg focus:font-bold"
      >
        انتقل إلى المحتوى الرئيسي
      </a>
      <Preloader />
      <WhatsAppButton />
      {mountChat && (
        <Suspense fallback={null}>
          <AIChatButton />
        </Suspense>
      )}
      <ScrollToTop />
      <Header />
      <main id="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
}
